<template>
  <v-container>
    <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/archive">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk31">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          January 31
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk1">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 1
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row> 
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk2">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 2
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk3">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 3
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk4">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 4
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>  
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk5">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 5
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk6">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 6
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk7">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 7
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk8">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 8
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk9">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 9
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk10">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 10
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>    
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk11">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 11
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk12">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 12
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>                       
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk13">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 13
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>    
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk14">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 14
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>          
        <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk15">
                      <v-btn
                          color="primary"
                          class="text-right"
                          style="width:500px"
                      >
                          February 15
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>      
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk9">
                      <v-btn
                          color="gray"
                          class="text-right"
                          style="width:500px"
                      >
                          February 16
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>      
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk9">
                      <v-btn
                          color="gray"
                          class="text-right"
                          style="width:500px"
                      >
                          February 17
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>      
      <v-row>
          <v-col cols="12">
              <div class="text-left">
                  <router-link to="/uk/uk9">
                      <v-btn
                          color="gray"
                          class="text-right"
                          style="width:500px"
                      >
                          February 18
                      </v-btn>
                  </router-link>
              </div>
          </v-col>
      </v-row>      
  </v-container>
</template>

<script>

//vue 3 style
import { ref } from 'vue'

export default {
  name: 'HomeView',
  setup() {
  }
}
</script>